<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-layer-plus', fontSet: 'fad'}"
	[headerText]="T.SHARED_EXPANSION_MOVE_TO_GROUP | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div class="groupHolderContainer">
			@for (checklistGroup of data.checklistGroups; track checklistGroup; let checklistGroupIndex = $index) {
				<div
					(click)="checklistGroupSelected(checklistGroup, checklistGroupIndex)"
					[class.selected]="checklistGroup.groupId === selectedChecklistGroup?.groupId"
					class="checklistGroup"
					mat-ripple
					role="button"
				>
					{{ checklistGroup.name }}
				</div>
			}
		</div>
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="close({action: 'cancel'})"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-times'}"
			[label]="T.BUTTON_CLOSE"
			color="warn"
			style="margin-right: 12px"
		/>

		<sim-button
			(onClick)="moveChecklistItem()"
			[disabled]="!selectedChecklistGroup"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.SHARED_EXPANSION_MOVE_CHECKLIST"
			color="accent"
		/>
	</ng-container>
</sim-basic-material-dialog>
